<template lang="pug">
transition(name="fade")
  .tract-number(v-show="show")
    GlobeObject.number(v-for="({position, index}, i) in tracts", :key="i", :position="position") {{index}}
</template>


<script lang="ts">
import { Vue, Component, Prop } from "vue-property-decorator";
import { RingsTract } from "./RingsTract";
import { ad2xyz } from '@/utils/math';
import { GlobeObject } from "@/stellar-globe-components/GlobeObject";
import { V3 } from "@/utils/math";
import { Frame, store } from '@/store';
import { TractModule } from '@/modules/TractModule';
import { Globe } from '@hscmap/stellar-globe';

function on(target: Globe["ee"], type: string, cb: () => void) {
  target.on(type, cb)
  return () => target.off(type, cb)
}

@Component({
  components: { GlobeObject },
})
export default class extends Vue {
  @Prop({ required: true })
  frame!: Frame

  @Prop({ required: true })
  module!: TractModule

  cameraMoving = false
  get show() {
    return this.module.show && !this.cameraMoving && this.frame.view.fovy <= 0.25
  }

  get ad() {
    const { a, d } = store.currentFrame.view
    return [a, d]
  }

  private offCameraMoveStart!: () => void
  private offCameraMoveEnd!: () => void

  mounted() {
    const globe = store.globe(this.frame)
    this.offCameraMoveStart = on(globe.ee, 'camera-move-start', () => { this.cameraMoving = true })
    this.offCameraMoveEnd = on(globe.ee, 'camera-move-end', () => { this.cameraMoving = false })
  }

  beforeDestroy() {
    this.offCameraMoveStart()
    this.offCameraMoveEnd()
  }

  get tracts() {
    const rt = this.module.rt
    const tracts: Array<{ position: V3, index: number }> = []
    const [a, d] = this.ad
    const i = rt.d2ringIndex(d)
    const { nw, nh } = this.module
    for (let ii = -nh; ii <= nh; ++ii) {
      const iii = i + ii
      const j = rt.ia2j(iii, a)
      for (let jj = -nw; jj <= nw; ++jj) {
        const jjj = j + jj
        const [aaa, ddd] = rt.ij2ad(iii, jjj)
        const position = ad2xyz(aaa, ddd) as V3
        const index = rt.ij2index(iii, jjj)
        tracts.push({ position, index })
      }
    }
    return tracts
  }
}

// type Timer = ReturnType<typeof setTimeout>

// function debounce(cb: () => void, wait: number) {
//     let timer: Timer | undefined
//     return () => {
//       if (timer != undefined) {
//         clearTimeout(timer)
//       }
//       timer = setTimeout(() => {
//         timer = undefined
//         cb()
//       }, wait)
//     }
// }
</script>


<style lang="scss" scoped>
.number {
  color: #0f0;
  pointer-events: none;
}

.fade-enter-active {
  transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>